import { Injectable } from '@angular/core';

@Injectable()
export class CustomLoadingService {

  // private _selector: string = 'loading-ng-app';
  private _selector: string = 'app-loading-container';
  private _element: any;

  constructor() {

    const interval = setInterval(() => {
      const elements = document.getElementsByClassName(this._selector)
      if (elements[0]) {
        this._element = elements[0];
        clearInterval(interval);
      }
    }, 200);

    // this._element =
  }

  public show(index?: number): void {
    if (this._element) {
      this._element.style['display'] = 'block';
      if (index)
        this._element.style['z-index'] = index;
    }
  }

  public hide(delay: number = 300): void {
    setTimeout(() => {
      if (this._element)
        this._element.style['display'] = 'none';
        var el = document.getElementById('loading-ng-app');
        if(el){
          el.style['display'] = 'none';
        }
    }, delay);
  }

}
